import {
  HttpClient
} from '@angular/common/http';
import {
  THIS_EXPR
} from '@angular/compiler/src/output/output_ast';
import {
  ComponentFactoryResolver,
  Injectable
} from '@angular/core';
import {
  Client
} from '@helium/http'
import {
  BehaviorSubject
} from 'rxjs';
import {
  GlobalsService
} from '../globals/globals.service';



const heliumclient = new Client();


@Injectable({
  providedIn: 'root'
})
export class HeliumService {



  // constructor(public globals: GlobalsService, private http: HttpClient) {}

  // private devs: any[] = [];


  // async getHotspotRewards(devices: string[]) {


  //   //getDayData
  //   devices = await this.getDayRewardsData(devices)

  //   //getWeekData
  //   devices = await this.getWeekRewardsData(devices)

  //   //getMonthData
  //   devices = await this.getMonthRewardsData(devices)

  //   //getTotalData
  //   devices = await this.getTotalRewardsData(devices)

  //   for (let i = 0; i < this.globals.deviceList.length; i++) {
  //     let dev: any = this.globals.deviceList[i];

  //     //Find device locally
  //     let index = this.globals.arrayFindWithAttr(this.devs, "address", dev.address);

  //     if (index != -1) {
  //       //Update 
  //       this.globals.deviceList[i]["earnings"] = this.devs[index].rewards
  //     }

  //   }

  //   this.globals.rewardsStatsLoaded = true;




  // }

  // async getDayRewardsData(devices: string[]) {

  //   let now = new Date();
  //   now.setUTCMinutes(0)
  //   now.setUTCSeconds(0)
  //   now.setUTCMilliseconds(0)

  //   for (let i = 0; i < devices.length; i++) {
  //     let deviceAddr = devices[i];

  //     //Get buckets
  //     let odr = await this.getHeliumRewards(deviceAddr, "hour", "-24 hour", now.toISOString());
  //     //Get totals 
  //     let tot = this.getTotals(odr);
  //     this.globals.rewards.total.day += tot;

  //     //Get device from local list
  //     let index = this.globals.arrayFindWithAttr(this.devs, 'address', deviceAddr);

  //     if (index != -1) {
  //       // update array 
  //       let rewards = this.devs[index].rewards;
  //       // rewards["day"] = oneDayRewards.total;
  //       rewards["day"] = tot;
  //       this.devs[index].rewards = rewards;
  //     } else {
  //       // add to array
  //       let device = {
  //         address: deviceAddr,
  //         rewards: {
  //           // day: oneDayRewards.total
  //           day: tot
  //         }
  //       }
  //       this.devs.push(device);

  //     }
  //   }

  //   this.globals.rewardsDayLoaded = true;

  //   return devices;
  // }

  // async getWeekRewardsData(devices: string[]) {

  //   let now = new Date();
  //   now.setUTCHours(0);
  //   now.setUTCMinutes(0);
  //   now.setUTCSeconds(0);
  //   now.setUTCMilliseconds(0);

  //   for (let i = 0; i < devices.length; i++) {
  //     let deviceAddr = devices[i];

  //     //Get buckets
  //     let odr = await this.getHeliumRewards(deviceAddr, "day", "-7 day", now.toISOString());
  //     //Get totals 
  //     let tot = this.getTotals(odr);
  //     this.globals.rewards.total.week += tot;

  //     //Get device from local list
  //     let index = this.globals.arrayFindWithAttr(this.devs, 'address', deviceAddr);


  //     if (index != -1) {
  //       // update array 
  //       let rewards = this.devs[index].rewards;
  //       rewards["week"] = tot;
  //       this.devs[index].rewards = rewards;
  //     } else {
  //       // add to array
  //       let device = {
  //         address: deviceAddr,
  //         rewards: {
  //           week: tot
  //         }
  //       }
  //       this.devs.push(device);

  //     }
  //   }


  //   this.globals.rewardsWeekLoaded = true;

  //   return devices;

  // }

  // async getMonthRewardsData(devices: string[]) {
  //   let now = new Date();
  //   now.setUTCHours(0)
  //   now.setUTCMinutes(0);
  //   now.setUTCSeconds(0);
  //   now.setUTCMilliseconds(0);
  //   for (let i = 0; i < devices.length; i++) {
  //     let deviceAddr = devices[i];

  //     // min_time: -30 day
  //     // max_time: 2022-01-04T00:00:00.000Z
  //     // bucket: day

  //     // let oneMonthRewards = await heliumclient.hotspot(deviceAddr).rewards.sum.get("-30 day");
  //     // this.globals.rewards.total.month += oneMonthRewards.total;


  //     //Get buckets
  //     let odr = await this.getHeliumRewards(deviceAddr, "day", "-30 day", now.toISOString());
  //     //Get totals 
  //     let tot = this.getTotals(odr);
  //     this.globals.rewards.total.month += tot;


  //     //Get device from local list
  //     let index = this.globals.arrayFindWithAttr(this.devs, 'address', deviceAddr);

  //     if (index != -1) {
  //       // update array 
  //       let rewards = this.devs[index].rewards;
  //       rewards["month"] = tot;
  //       this.devs[index].rewards = rewards;
  //     } else {
  //       // add to array
  //       let device = {
  //         address: deviceAddr,
  //         rewards: {
  //           month: tot
  //         }
  //       }
  //       this.devs.push(device);

  //     }

  //   }
  //   this.globals.rewardsMonthLoaded = true;

  //   return devices;

  // }

  // async getTotalRewardsData(devices: string[]) {
  //   let now = new Date();
  //   now.setUTCHours(0)
  //   now.setUTCMinutes(0);
  //   now.setUTCSeconds(0);
  //   now.setUTCMilliseconds(0);

  //   for (let i = 0; i < devices.length; i++) {
  //     let deviceAddr = devices[i];

  //     //Get buckets
  //     let odr = await this.getHeliumRewards(deviceAddr, "week", "-52 week", now.toISOString());
  //     //Get totals 
  //     let tot = this.getTotals(odr);
  //     this.globals.rewards.total.total += tot;

  //     //Get device from local list
  //     let index = this.globals.arrayFindWithAttr(this.devs, 'address', deviceAddr);

  //     if (index != -1) {
  //       // update array 
  //       let rewards = this.devs[index].rewards;
  //       rewards["total"] = tot;
  //       this.devs[index].rewards = rewards;
  //     } else {
  //       // add to array
  //       let device = {
  //         address: deviceAddr,
  //         rewards: {
  //           total: tot
  //         }
  //       }
  //       this.devs.push(device);

  //     }
  //   }
  //   this.globals.rewardsTotalLoaded = true;

  //   return devices;

  // }


  // async getHotspotStats(devices: string[], scope, loadedCallback: (scope) => void) {

  //   let synced = 0;
  //   let relayedCount = 0;
  //   let online = 0;
  //   let offline = 0;
  //   let deviceList = []

  //   for (let i = 0; i < devices.length; i++) {

  //     let deviceAddr = devices[i];

  //     // let dev = await heliumclient.hotspots.get(deviceAddr)
  //     let dev = await this.getHeliumHotspot(deviceAddr)

  //     let status: any = dev.status;
  //     //Check online/offline
  //     if (status.online == "online") online++;
  //     if (status.online == "offline") offline++;

  //     //Check synced
  //     let syncedPercentage = status.height / dev.block * 100 > 100 ? 100 : status.height / dev.block * 100;
  //     status.synced = false;

  //     //TODO: determine syncedPercentage acceptable
  //     if (syncedPercentage > 98) {
  //       synced++;
  //       status.synced = true;
  //     }
  //     status.syncedPercentage = syncedPercentage;


  //     //check Check relayed :  ListenAddr contains p2p
  //     let relayed = false;
  //     status.publicIP = "0.0.0.0"
  //     for (let j = 0; j < status.listen_addrs.length; j++) {

  //       if (status.listen_addrs[j].includes("p2p")) {
  //         relayed = true
  //       }
  //     }
  //     status.relayed = relayed
  //     if (relayed == true) relayedCount++

  //     //Update global devicelist
  //     dev.status = status;
  //     deviceList.push(dev);

  //   }

  //   this.globals.deviceList = deviceList;
  //   this.globals.synced = synced;
  //   this.globals.relayed = relayedCount;
  //   this.globals.online = online;
  //   this.globals.statsloaded = true;
  //   this.globals.offline = offline;

  //   loadedCallback(scope);

  // }


  // getHeliumRewards(address: string, bucket: string, min_time: string, max_time: string) {


  //   return new Promise < any > (async (resolve, reject) => {
  //     try {


  //       let endpoint = `https://helium-api.stakejoy.com/v1/hotspots/${address}/rewards/sum?min_time=${min_time}&max_time=${max_time}&bucket=${bucket}`


  //       // let ob = this.http.post(endpoint, body, options);

  //       let ob1 = this.http.get(endpoint)
  //       ob1.subscribe(
  //         response => {
  //           let r: any = response;

  //           resolve(r.data)
  //         },

  //         error => {}
  //       );
  //     } catch (e) {
  //       //Failure
  //       reject(e);
  //     }
  //   });




  // }

  // getHeliumHotspot(address: string) {


  //   return new Promise < any > (async (resolve, reject) => {
  //     try {


  //       let endpoint = `https://helium-api.stakejoy.com/v1/hotspots/${address}`


  //       // let ob = this.http.post(endpoint, body, options);

  //       let ob1 = this.http.get(endpoint)
  //       ob1.subscribe(
  //         response => {
  //           let r: any = response;

  //           resolve(r.data)
  //         },

  //         error => {}
  //       );
  //     } catch (e) {
  //       //Failure
  //       reject(e);
  //     }
  //   });




  // }

  // getTotals(bucketArray: any[]) {
  //   let total = 0;

  //   for (let i = 0; i < bucketArray.length; i++) {
  //     let entry = bucketArray[i]

  //     total += entry.total;
  //   }

  //   return total;
  // }
}
